import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import {
  FiUser,
  FiBriefcase,
  FiMail,
  FiPhone,
  FiMessageSquare,
  FiArrowRight,
  FiFileText,
} from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contactCards } from "../Data";
import { useRecaptcha } from "../Components/ReCaptcha";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

const ContactSection = () => {
  const formRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const generateToken = useRecaptcha();

  const [formData, setFormData] = useState({
    subject: "",
    name: "",
    business: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* ==========================================
       VALIDATION
    ========================================== */

    if (!formData.name.trim()) {
      toast.error("Please enter your name.");
      return;
    }

    if (!formData.business.trim()) {
      toast.error("Please enter your business name.");
      return;
    }

    if (!formData.email.trim()) {
      toast.error("Please enter your work email.");
      return;
    }

    if (!formData.phone.trim()) {
      toast.error("Please enter your contact number.");
      return;
    }

    if (!formData.subject.trim()) {
      toast.error("Please enter a subject.");
      return;
    }

    if (!formData.message.trim()) {
      toast.error("Please enter your message.");
      return;
    }

    setLoading(true);

      generateToken(async (token) => {

    try {

      // ✅ VERIFY RECAPTCHA
      const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Le8-4ktAAAAACnqexkKznBsqgEu7kvPLemu9hUT"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      console.log(
        "FULL RESPONSE:",
        verifyRes.data
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;

      console.log(
        "Recaptcha Score:",
        score
      );

      // ✅ BLOCK SPAM
      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

const template = `
      <div style="
        margin:0;
        padding:30px 15px;
        background:#ffffff;
        font-family:'Poppins',Arial,Helvetica,sans-serif;
      ">

        <table
          width="100%"
          cellpadding="0"
          cellspacing="0"
          border="0"
        >
          <tr>
            <td align="center">

              <!-- MAIN CONTAINER -->
              <table
                width="600"
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  width:100%;
                  max-width:600px;
                  background:#ffffff;
                  border:2px solid #0FAE4D;
                "
              >

                <!-- HEADER -->
                <tr>
                  <td
                    align="center"
                    style="
                      background:#0FAE4D;
                      padding:28px 25px;
                    "
                  >

                    <img
                      src="https://onbbits.io/logo-white.svg"
                      alt="ONBBITS"
                      width="145"
                      style="
                        display:block;
                        width:145px;
                        max-width:100%;
                        height:auto;
                        margin:0 auto 18px;
                      "
                    />

                    <h1
                      style="
                        margin:0;
                        padding:0;
                        color:#ffffff;
                        font-family:'Poppins',Arial,Helvetica,sans-serif;
                        font-size:22px;
                        line-height:1.4;
                        font-weight:600;
                      "
                    >
                      New Contact Message
                    </h1>

                  </td>
                </tr>


                <!-- CONTENT -->
                <tr>
                  <td
                    style="
                      padding:28px;
                      background:#ffffff;
                    "
                  >

                    <!-- INTRO -->
                    <p
                      style="
                        margin:0 0 22px;
                        color:#000000;
                        font-family:'Poppins',Arial,Helvetica,sans-serif;
                        font-size:13px;
                        line-height:1.7;
                      "
                    >
                      A new message has been submitted through the ONBBITS website contact form.
                    </p>


                    <!-- CONTACT INFORMATION -->
                    <table
                      width="100%"
                      cellpadding="0"
                      cellspacing="0"
                      border="0"
                      style="
                        border:1px solid #282828;
                      "
                    >

                      <!-- SECTION HEADING -->
                      <tr>
                        <td
                          colspan="2"
                          style="
                            padding:12px 15px;
                            background:#EFFFF5;
                            border-bottom:1px solid #282828;
                          "
                        >
                          <p
                            style="
                              margin:0;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:14px;
                              line-height:1.4;
                              font-weight:600;
                            "
                          >
                            Contact Information
                          </p>
                        </td>
                      </tr>


                      <!-- NAME + BUSINESS -->
                      <tr>

                        <td
                          width="50%"
                          style="
                            padding:15px;
                            border-bottom:1px solid #EFFFF5;
                            border-right:1px solid #EFFFF5;
                            vertical-align:top;
                          "
                        >

                          <p
                            style="
                              margin:0 0 4px;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:10px;
                              line-height:1.4;
                              font-weight:500;
                              text-transform:uppercase;
                            "
                          >
                            Name
                          </p>

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.5;
                              font-weight:500;
                            "
                          >
                            ${formData.name}
                          </p>

                        </td>


                        <td
                          width="50%"
                          style="
                            padding:15px;
                            border-bottom:1px solid #EFFFF5;
                            vertical-align:top;
                          "
                        >

                          <p
                            style="
                              margin:0 0 4px;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:10px;
                              line-height:1.4;
                              font-weight:500;
                              text-transform:uppercase;
                            "
                          >
                            Business Name
                          </p>

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.5;
                              font-weight:500;
                            "
                          >
                            ${formData.business}
                          </p>

                        </td>

                      </tr>


                      <!-- EMAIL + PHONE -->
                      <tr>

                        <td
                          width="50%"
                          style="
                            padding:15px;
                            border-bottom:1px solid #EFFFF5;
                            border-right:1px solid #EFFFF5;
                            vertical-align:top;
                          "
                        >

                          <p
                            style="
                              margin:0 0 4px;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:10px;
                              line-height:1.4;
                              font-weight:500;
                              text-transform:uppercase;
                            "
                          >
                            Work Email
                          </p>

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.5;
                              font-weight:500;
                              word-break:break-word;
                            "
                          >
                            ${formData.email}
                          </p>

                        </td>


                        <td
                          width="50%"
                          style="
                            padding:15px;
                            border-bottom:1px solid #EFFFF5;
                            vertical-align:top;
                          "
                        >

                          <p
                            style="
                              margin:0 0 4px;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:10px;
                              line-height:1.4;
                              font-weight:500;
                              text-transform:uppercase;
                            "
                          >
                            Contact Number
                          </p>

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.5;
                              font-weight:500;
                            "
                          >
                            ${formData.phone}
                          </p>

                        </td>

                      </tr>


                      <!-- SUBJECT -->
                      <tr>

                        <td
                          colspan="2"
                          style="
                            padding:15px;
                            vertical-align:top;
                          "
                        >

                          <p
                            style="
                              margin:0 0 4px;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:10px;
                              line-height:1.4;
                              font-weight:500;
                              text-transform:uppercase;
                            "
                          >
                            Subject
                          </p>

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.5;
                              font-weight:500;
                            "
                          >
                            ${formData.subject}
                          </p>

                        </td>

                      </tr>

                    </table>


                    <!-- MESSAGE -->
                    <table
                      width="100%"
                      cellpadding="0"
                      cellspacing="0"
                      border="0"
                      style="
                        margin-top:20px;
                        border:1px solid #282828;
                      "
                    >

                      <tr>
                        <td
                          style="
                            padding:12px 15px;
                            background:#EFFFF5;
                            border-bottom:1px solid #282828;
                          "
                        >

                          <p
                            style="
                              margin:0;
                              color:#282828;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:14px;
                              line-height:1.4;
                              font-weight:600;
                            "
                          >
                            Message
                          </p>

                        </td>
                      </tr>


                      <tr>
                        <td
                          style="
                            padding:15px;
                          "
                        >

                          <p
                            style="
                              margin:0;
                              color:#000000;
                              font-family:'Poppins',Arial,Helvetica,sans-serif;
                              font-size:13px;
                              line-height:1.7;
                              font-weight:400;
                              white-space:pre-line;
                            "
                          >
                            ${formData.message}
                          </p>

                        </td>
                      </tr>

                    </table>

                  </td>
                </tr>


                <!-- FOOTER -->
                <tr>
                  <td
                    align="center"
                    style="
                      background:#0FAE4D;
                      padding:20px 25px;
                    "
                  >

                    <p
                      style="
                        margin:0;
                        color:#ffffff;
                        font-family:'Poppins',Arial,Helvetica,sans-serif;
                        font-size:14px;
                        line-height:1.5;
                        font-weight:600;
                      "
                    >
                      ONBBITS
                    </p>

                    <p
                      style="
                        margin:4px 0 0;
                        color:#ffffff;
                        font-family:'Poppins',Arial,Helvetica,sans-serif;
                        font-size:10px;
                        line-height:1.5;
                        font-weight:400;
                      "
                    >
                      WhatsApp Business Automation Platform
                    </p>

                    <p
                      style="
                        margin:8px 0 0;
                        color:#ffffff;
                        font-family:'Poppins',Arial,Helvetica,sans-serif;
                        font-size:9px;
                        line-height:1.5;
                        font-weight:400;
                      "
                    >
                      © ${new Date().getFullYear()} ONBBITS. All rights reserved.
                    </p>

                  </td>
                </tr>

              </table>

            </td>
          </tr>
        </table>

      </div>
    `;


      /* ==========================================
         FORM DATA FOR API
      ========================================== */

      const data = new FormData();

      data.append(
        "title",
        "ONBBITS Contact Form"
      );

      data.append(
        "to_email",
        "sales@onbbits.io"
      );

      data.append(
        "cc",
        "arkayappsseo@gmail.com,sales@arkayapps.com"
      );

      data.append(
        "subject",
        `ONBBITS Contact Form - ${formData.subject}`
      );

      data.append(
        "template",
        template
      );


      /* ==========================================
         SEND EMAIL
      ========================================== */

      await axios.post(
        "https://api.sendmail.adhyaynam.in/send-mail/two",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      /* ==========================================
         SUCCESS
      ========================================== */

      toast.success(
        "Your message has been sent successfully!"
      );

      setFormData({
        subject: "",
        name: "",
        business: "",
        email: "",
        phone: "",
        message: "",
      });

    } catch (error) {

      console.log(
        error.response?.data || error
      );

      toast.error(
        "Verification failed. Please try again!"
      );

    } finally {

      setLoading(false);

    }
  })
  };


  return (
    <section
      className="contact-section container"
      ref={formRef}
    >

      {/* TOAST */}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />


      {/* TOP CENTER HEADING */}

      <motion.div
        className="contact-header"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >

        <h2 className="section-heading">
          Send us a message
        </h2>

        <p className="section-text top-para">
          We'll get back to you within 2 business hours.
        </p>

      </motion.div>


      {/* CONTENT GRID */}

      <div className="contact-grid">


        {/* LEFT CARDS */}

        <motion.div
          className="contact-left"
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          {contactCards.map((item, index) => {

            const Icon = item.icon;

            return (

              <motion.div
                key={index}
                className="contact-card"
                variants={fadeUp}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.2 }}
              >

                <div className="contact-icon">
                  <Icon />
                </div>

                <h3 className="card-heading">
                  {item.title}
                </h3>

                <p className="section-text">
                  {item.desc}
                </p>


                {item.type === "internal" ? (

                  <Link
                    to={item.url}
                    className="contact-link"
                  >
                    {item.link}
                    <FiArrowRight />
                  </Link>

                ) : (

                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    {item.link}
                    <FiArrowRight />
                  </a>

                )}

              </motion.div>

            );

          })}

        </motion.div>


        {/* RIGHT FORM */}

        <motion.div
          className="contact-right"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          <form onSubmit={handleSubmit}>

            <motion.div
              className="form-grid"
              variants={stagger}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >


              {/* NAME */}

              <motion.div
                className="input-group"
                variants={fadeUp}
              >

                <label>
                  Your Name *
                </label>

                <div className="input-box">

                  <FiUser />

                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter Your Name"
                  />

                </div>

              </motion.div>


              {/* BUSINESS */}

              <motion.div
                className="input-group"
                variants={fadeUp}
              >

                <label>
                  Business Name *
                </label>

                <div className="input-box">

                  <FiBriefcase />

                  <input
                    type="text"
                    name="business"
                    value={formData.business}
                    onChange={handleChange}
                    placeholder="Enter Your Business Name"
                  />

                </div>

              </motion.div>


              {/* EMAIL */}

              <motion.div
                className="input-group"
                variants={fadeUp}
              >

                <label>
                  Work Email *
                </label>

                <div className="input-box">

                  <FiMail />

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Work Email"
                  />

                </div>

              </motion.div>


              {/* PHONE */}

              <motion.div
                className="input-group"
                variants={fadeUp}
              >

                <label>
                  Contact Number *
                </label>

                <div className="input-box">

                  <FiPhone />

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Your Contact Number"
                  />

                </div>

              </motion.div>


              {/* SUBJECT */}

              <motion.div
                className="input-group full-width"
                variants={fadeUp}
              >

                <label>
                  Subject *
                </label>

                <div className="input-box">

                  <FiFileText />

                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Enter Subject"
                  />

                </div>

              </motion.div>


              {/* MESSAGE */}

              <motion.div
                className="input-group full-width"
                variants={fadeUp}
              >

                <label>
                  Message *
                </label>

                <div className="input-box textarea">

                  <FiMessageSquare />

                  <textarea
                    rows="5"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Enter Your Message"
                  />

                </div>

              </motion.div>

            </motion.div>


            {/* BUTTON */}

            <motion.button
              className="contact-btn btn btn-primary"
              type="submit"
              disabled={loading}
              variants={fadeUp}
              whileHover={{
                y: loading ? 0 : -4,
              }}
              whileTap={{
                scale: loading ? 1 : 0.97,
              }}
              transition={{
                duration: 0.2,
              }}
            >

              {loading
                ? "Sending..."
                : "Send Message"
              }

              {!loading && (
                <FiArrowRight />
              )}

            </motion.button>

          </form>

        </motion.div>

      </div>

    </section>
  );
};

export default ContactSection;